var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-alert",
        {
          staticClass: "intro",
          attrs: { type: "warning", closable: false, "show-icon": "" },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("placesProvider.introTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("placesProvider.introBody"))),
          ]),
        ]
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("placesProvider.cardTitle"))),
          ]),
          _vm.state
            ? _c("div", { staticClass: "state-row" }, [
                _c("div", { staticClass: "state-block" }, [
                  _c("div", { staticClass: "state-label" }, [
                    _vm._v(_vm._s(_vm.$t("placesProvider.active"))),
                  ]),
                  _c("div", { staticClass: "state-value" }, [
                    _vm._v(_vm._s(_vm.labelFor(_vm.state.active))),
                  ]),
                ]),
                _c("div", { staticClass: "state-block" }, [
                  _c("div", { staticClass: "state-label" }, [
                    _vm._v(_vm._s(_vm.$t("placesProvider.fallback"))),
                  ]),
                  _c("div", { staticClass: "state-value muted" }, [
                    _vm._v(_vm._s(_vm.labelFor(_vm.state.fallback))),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.state
            ? _c(
                "el-radio-group",
                {
                  staticClass: "choices",
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                _vm._l(_vm.state.supported, function (p) {
                  return _c(
                    "div",
                    { key: p, staticClass: "choice" },
                    [
                      _c("el-radio", { attrs: { label: p, border: "" } }, [
                        _vm._v(_vm._s(_vm.labelFor(p))),
                      ]),
                      _c("div", { staticClass: "choice-note" }, [
                        _vm._v(_vm._s(_vm.noteFor(p))),
                      ]),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.saving,
                    disabled: !_vm.state || _vm.selected === _vm.state.active,
                  },
                  on: { click: _vm.confirmSave },
                },
                [_vm._v(" " + _vm._s(_vm.$t("placesProvider.save")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { disabled: _vm.loading }, on: { click: _vm.fetch } },
                [_vm._v(_vm._s(_vm.$t("placesProvider.refresh")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "fields-card" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm.$t("placesProvider.fieldsTitle"))),
          ]),
          _c("div", { staticClass: "intro-body" }, [
            _vm._v(_vm._s(_vm.$t("placesProvider.fieldsBody"))),
          ]),
          _c(
            "el-table",
            {
              staticClass: "fields-table",
              attrs: { data: _vm.fieldRows, border: "", fit: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("placesProvider.field"),
                  "min-width": "200",
                  prop: "field",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Google Places",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("i", {
                          class: row.google
                            ? "el-icon-check ok"
                            : "el-icon-close bad",
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Geoapify", width: "140", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("i", {
                          class: row.geoapify
                            ? "el-icon-check ok"
                            : "el-icon-close bad",
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }